import type { SVGProps } from 'react';
import React from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function CheckboxActive({ className, ...rest }: IProps) {
  return (
    <svg
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <g
        id="4.-Radio-Button/Old/Check/1.-Check"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle-Copy-6"
          fill="#1E3D5A"
          x="0"
          y="0"
          width="28"
          height="28"
        ></rect>
        <polyline
          id="Path-Copy-4"
          stroke="#FFFFFF"
          strokeWidth="2"
          transform="translate(14.000000, 14.000000) scale(-1, 1) rotate(-180.000000) translate(-14.000000, -14.000000) "
          points="7 14.4615385 12.5 8 21 20"
        ></polyline>
      </g>
    </svg>
  );
}
